import { TextField, Typography, type SxProps, type Theme } from '@mui/material'
import type React from 'react'
import { defaultSx } from './SurveyTextField.styles'

interface SurveyTextFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  placeholder?: string
  rows?: number
  height?: string | number
  multiline?: boolean
  disabled?: boolean
  type?: string
  autoComplete?: string
  errorText?: string
  dataTestId?: string
  sx?: SxProps<Theme>
}

export const SurveyTextField: React.FC<SurveyTextFieldProps> = ({
  value,
  onChange,
  onBlur,
  placeholder,
  dataTestId,
  height,
  type,
  autoComplete,
  errorText,
  multiline = true,
  disabled = false,
  rows = 3,
  sx
}) => {
  const hasError = errorText != null && errorText !== ''
  const errorId = dataTestId != null ? `${dataTestId}-error` : undefined

  return (
    <>
      <TextField
        multiline={multiline}
        variant="filled"
        className='surveyQuestionField'
        disabled={disabled}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        type={type}
        autoComplete={autoComplete}
        error={hasError}
        placeholder={placeholder ?? 'Add details here'}
        rows={multiline ? rows : undefined}
        data-testid={dataTestId}
        inputProps={hasError ? { 'aria-invalid': true, 'aria-describedby': errorId } : undefined}
        sx={{
          ...defaultSx,
          ...(multiline && height != null && { height }),
          ...sx
        }}
      />
      {hasError && (
        <Typography id={errorId} data-testid={errorId} role='alert' className='surveyFieldError' sx={{ color: 'error.main', mt: '8px' }}>
          {errorText}
        </Typography>
      )}
    </>
  )
}
